import { actionsNamespace } from "../actions-namespace"

export const floatWindowActionNamespace = `${actionsNamespace}floatwindow/`
